// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Norfolk Island */
const NF = /^(?:(?:14|3[58])\d{4})$/;

export default NF;
